import { Message } from 'element-ui'
// 基于elementui 提示 进行 二次封装
export default function showmessage(
  message = '请求数据失败',
  type = 'error',
  duration = 1500
) {
  Message({
    message,
    type,
    duration
  })
}
